import  { useState, useEffect, useRef } from 'react';
import { motion, useAnimation, AnimatePresence  } from "framer-motion"; 
// import { useAccessChatMutation } from 'context/chat/chatApiSlice';
import { useReactToReviewMutation } from 'context/review/reviewApiSlice';
import MDAvatar from "dashboard/components/MDAvatar";
import ClickAwayListener from '@mui/material/ClickAwayListener';

// import MDTypography from "dashboard/components/MDTypography";

const cardVariants = {
    hidden: {
    y: -40,
    x: 50,
    opacity : 0
  },
  visible: {
    y: -40,
    opacity : 1,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.7,
      when: "beforeChildren",
      // delayChildren: 0.5,
      staggerChildren: 0.5
      // staggerChildren :1
    }
  }
};

const emojiVariant = {
    hidden : {opacity : 0 ,scale: 0, y : 50 },
    visible : {opacity : 1 ,scale : 1, y : 0,  transition: {
      // delay :.6,
      duration : .4
    }}
}
const images = [
    { id: "like", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/like.gif`, hueA : 205, hueB : 245 },
    { id: "love", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/love.gif` , hueA : 290, hueB : 320},
    { id: "haha", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/haha.gif`, hueA : 60, hueB : 90 },
    { id: "yay", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/yay.gif`, hueA : 60, hueB : 90 },
    { id: "wow", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/wow.gif`, hueA : 60, hueB : 90 },
    { id: "sad", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/sad.gif`, hueA : 260, hueB : 290 },
    { id: "angry", img: `${process.env.REACT_APP_PUBLIC_URL}/img/reactions/angry.gif`, hueA : 340, hueB : 10 },
  ];
const cardContainer = {
  display: 'flex',
  background: 'white',
  borderRadius: '20px',
  boxShadow: '0 0 1px hsl(0deg 0% 0% / 0.075), 0 0 2px hsl(0deg 0% 0% / 0.075), 0 0 4px hsl(0deg 0% 0% / 0.075), 0 0 8px hsl(0deg 0% 0% / 0.075), 0 0 16px hsl(0deg 0% 0% / 0.075)',
  padding : 5,
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top :0,
  left:0,
} 
const Reactions = ({ reactTo, showAlerts, setReplayToReview}) => {
    const controls = useAnimation();
    const [open,setOpen] = useState(false);
    const [reactToReview,{isLoading}] = useReactToReviewMutation();
    const reactionsRef = useRef(null);

    const handleOpen = ()=>{
      if(!reactTo.position) return;
      cardVariants.visible.y = reactTo.position.y;
      cardVariants.visible.x = reactTo.position.x + 40;
      cardVariants.hidden.y  = reactTo.position.y - 40;
      cardVariants.hidden.x  = reactTo.position.x + 40;
      
      setOpen(true)
    }

    const handleClose = ()=>{
      controls.start("hidden");
      setReplayToReview(prev=>({...prev, position:{x:0,y:0}}))
    }

    const handleClick = async reaction => {
       try{
          const reactionReasponse = await reactToReview({filter:reactTo.id, update:{user : reactTo.user, review : reactTo.id, content : reaction}});
          showAlerts({
            title : `Your ${reaction}ed this review` ,
            type  : "toast",
            msg :  reactionReasponse.message,
            color :"success"
        })
        handleClose();
       }catch(error){
            showAlerts({
              title : "Review Alert",
              type  : "toast",
              msg :  error.data?.error || error.error,
              color :"error"
          })
       }
    }
    const imgsLayout = images.map( img =>(
        <motion.div key={img.id} variants={emojiVariant}  initial="hidden" animate="visible">
        <MDAvatar sx={{m:.5, cursor : "pointer", opacity:isLoading ? .5 :1 }} onClick={()=>handleClick(img.id)}   src={`${img.img}`}  alt={img.id} size="sm" shadow="sm" />
        </motion.div>)
    )
    

    const onComplete = e =>{
      /*eslint-disable*/
      e === "hidden" && setOpen(false)
    }

    useEffect(()=>{
        /*eslint-disable*/
        if(!reactTo || !reactTo?.position) return;
         reactTo?.position?.y !== 0  ?  handleOpen() : null;
    },[reactTo])
    
    useEffect(() => {
      open && controls.start("visible");
      return () => {
        controls.start("hidden");
      }
    }, [open])

    


  return (
    <AnimatePresence initial={false}>
      {open && (<ClickAwayListener onClickAway={handleClose}>  
         <motion.div 
         ref={reactionsRef}
         layout
         initial="hidden"
         onMouseLeave={handleClose}  
         onAnimationComplete={onComplete}
         style={cardContainer} 
         animate={controls}
         variants={cardVariants}
         >
          {imgsLayout}
        </motion.div>
        </ClickAwayListener>)}
    </AnimatePresence>
  )
};

export default Reactions
